module.exports = __webpack_public_path__ + "img/10.cefe6741.jpg";